import { ComponentPropsWithRef, KeyboardEvent, useCallback } from 'react';
import * as S from './styles';

type Props = Omit<ComponentPropsWithRef<'input'>, 'type'>;

export const Switch = (props: Props) => {
  const onKeyUp = useCallback(
    (event: KeyboardEvent) => {
      if (event?.key === 'Enter') {
        // @ts-ignore: An argument for 'event' was not provided.
        props.onChange && props.onChange();
      }
    },
    [props],
  );

  return (
    <S.Container>
      <S.Input {...props} onKeyUp={onKeyUp} />
      <S.Slider />
    </S.Container>
  );
};
